module.exports = __webpack_public_path__ + "media/images/blog-header-bg-823d405a9f232a9f4fa3947d8caa1532.jpg";